import { getDocs, collection, query, where } from "firebase/firestore";
import { firestore_database } from "@src/utility_functions/database_operations/config/firebaseConfig";

export const fetchFirestoreUserObjectFromEmail = async (firebaseEmail) => {
  let returnValue;
  try {
    var usersCollection = query(
      collection(firestore_database, "users"),
      where("email", "==", firebaseEmail),
    );
    var querySnapshot = await getDocs(usersCollection);
    var documentReference = querySnapshot.docs[0];
    returnValue = documentReference.data();
  } catch (error) {
    console.warn(error);
    returnValue = undefined;
  }
  return returnValue;
};
